// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDFCxCoi1k7kRJyu9oJPARtZ7NrhUXkND4",
  authDomain: "ice-track-d3065.firebaseapp.com",
  projectId: "ice-track-d3065",
  storageBucket: "ice-track-d3065.appspot.com",
  messagingSenderId: "911130390469",
  appId: "1:911130390469:web:6af7ce2acc40d90022a5ac"
};

// Initialize Firebase
initializeApp(firebaseConfig);